import { getRangeValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'rentCommission' as const;

export const rentCommissionTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const { lte: commission = null } = getRangeValue('commission')(jsonQuery) || {};

    if (commission === null) {
      return null;
    }

    const label = commission === 0 ? 'Без комиссии' : `Комиссия до ${commission}%`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['commission'])(jsonQuery),
};
